import React from "react";
import { useNavigate } from "react-router-dom";

const WelcomePage = () => {
    const navigate = useNavigate();

    const onStartClick = () => {
        if (localStorage.getItem("user")) {
            navigate("/score");
        } else {
            navigate("/user-details");
        }
    };

    return (
        <div className="App">
            <div className="App-header">
                Functional Similarity Evaluation
            </div>
            <div className="description">
                <b style={{ fontWeight: "bold", fontSize: "1.3rem" }}>Welcome to the Functional Similarity Evaluation!</b>
                <br /><span style={{ color: "#00CBC4", fontWeight: "bold", textAlign: "justify" }}>Scope:</span>
                <span style={{ marginTop: "15px", textAlign: "justify" }}>This task is part of a research study conducted by the PhD student Karanikiotis Thomas, under the supervision of professor Andreas L. Symeonidis. The goal of this study is to evaluate the effectiveness of different methods for assessing the functional similarity of code snippets. Your participation is greatly appreciated and will help us improve the quality of our research.</span>
                <br /><span style={{ color: "#00CBC4", fontWeight: "bold", textAlign: "justify" }}>Instructions:</span>
                <span style={{ marginTop: "15px", textAlign: "justify" }}>In this task, you are presented with two random code snippets, based on the programming languages you are familiar with. Your role is to carefully evaluate how similar these snippets are in terms of functionality. Please focus on the <span style={{ textDecoration: "underline" }}>operations they perform</span> and the outcomes they achieve, <span style={{ textDecoration: "underline" }}>rather than their syntax or code structure</span>.</span>
                <span style={{ marginTop: "15px", textAlign: "justify" }}>The similarity score should be assigned as a percentage, where 0% indicates completely different functionality, and 100% means identical functionality. For instance, if one snippet has a function that is somewhat similar to an operation in the other, yet there are many more non-overlapping functions, you might score the similarity around 10%.</span>
                <span style={{ marginTop: "15px", textAlign: "justify" }}>If you encounter a pair of snippets where the similarity is unclear, please use the <b>Skip</b> button to move on to a new set of snippets.</span>
                <br />
                <b style={{ fontWeight: "bold" }}>Thank you for your participation!</b>
            </div>
            <button
              className="submit-button"
              onClick={onStartClick}
            >
              Start
            </button>
        </div>
    );
};

export default WelcomePage;
